import { PIMInformationBox } from './PIMInformationBox';

export default PIMInformationBox;
